import React from "react";
//import PropTypes from 'prop-types';
import { FormSection } from "playground/cms/Form";
import Button from "components/Button";
import { useApiActions } from "state/hooks";
import { updateConfiguration } from "cms/state/actions/integrations";

export function NfHotel(props) {
    const { id } = props;

    const { onUpdate } = useApiActions({
        onUpdate: updateConfiguration,
    });

    const updateConfig = () => onUpdate(id);

    return (
        <FormSection name={"Aktualizacja konfiguracji"}>
            <Button onClick={updateConfig}>Aktualizuj teraz</Button>
        </FormSection>
    );
}

NfHotel.propTypes = {};

NfHotel.defaultProps = {};

export default NfHotel;
